import { useEffect, useRef } from 'react';
import type { RefObject, ReactElement, Ref } from 'react';

import { useMergedRef, useRovingIndex } from '../../hooks';

type Options = Parameters<ReturnType<typeof useRovingIndex>['item']>[1];

type Props<T extends HTMLElement> = {
  ref?: Ref<T>;
  children: (props: { ref: RefObject<T | null> }) => ReactElement;
  options?: Options;
};

export function RovingIndexItem<T extends HTMLElement>({
  children,
  options = {},
  ref,
}: Props<T>) {
  const mergedRef = useMergedRef<T>(ref);
  const optionsRef = useRef<Options>(options);
  optionsRef.current = options;

  const rovingIndex = useRovingIndex();

  useEffect(
    () => rovingIndex.item(mergedRef, optionsRef.current),
    [rovingIndex],
  );

  return children({ ref: mergedRef });
}
